import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface RequestDetails {
  page: number;
  record: number;
  portfolio: string[];
  productProxyOwner: number[];
  search: string;
}

interface Product {
  ProductId: string;
  Name: string;
  Description: string;
  DescriptionShort: string;
  UpdatedDtm: string;
  ProductOwner: [{ Name: string; Email: string }];
  ProductManager: [{ name: string; Email: string }];
  ProxyOwner: [{ Name: string; Email: string }];
}

interface ProductListState {
  isLoading: boolean;
  data: {
    Page: number;
    Record: number;
    TotalRecords: number;
    TotalPages: number;
    Data: Product[];
  } | null;
  error: string | null;
}

const initialState: ProductListState = {
  isLoading: true,
  data: {
    Page: 1,
    Record: 0,
    TotalRecords: 0,
    TotalPages: 0,
    Data: [],
  },
  error: null,
};

export const fetchProductListData = createAsyncThunk<any, RequestDetails>(
  "CTDBProductListSlice/fetchProductListData",
  async (requestDetails, thunkApi) => {
    try {
      const response = await httpClient.post("/db/product", {
        Page: requestDetails.page,
        Record: requestDetails.record,
        Portfolio: requestDetails.portfolio,
        ProductProxyOwner: requestDetails.productProxyOwner,
        Search: requestDetails.search,
        Action: "retrieveAll",
      });

      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to get product list",
          });
        }
      }
      return response.data;
    } catch (error) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to get product list",
      });
    }
  }
);

const CTDBProductListSlice = createSlice({
  name: "CTDBProductListSlice",
  initialState,
  reducers: {
    resetProductState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductListData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        fetchProductListData.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload.Data;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        fetchProductListData.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetProductState } = CTDBProductListSlice.actions;
export default CTDBProductListSlice.reducer;
